import { defineComponent, ref, computed } from "vue";
import { showStatusOption } from "@/views/repository/resource/config/option";
import { templateAudit, templateStatus, updateTemplate } from "@/api/veditor/index";
import { definePropType } from "@types-vue/props";
import { OperationStatus } from "../index";
import TableFromMpdel from "../from";
import { Message } from "element-ui";
export default defineComponent({
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        ids: {
            type: definePropType(Array),
            default: ""
        },
        operationType: {
            type: definePropType(String),
            default: ""
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var resetFields = function resetFields() {
            tag_ids.value = [];
            show_status.value = 2;
            audit_status.value = "approved";
            remark.value = "";
        };
        var successForm = function successForm() {
            Message.success("\u64CD\u4F5C\u6210\u529F");
            loading.value = false;
            emit("refreshTemplateList");
            handleClose();
        };
        var template_tags = TableFromMpdel().template_tags;
        var loading = ref(false);
        var tag_ids = ref([]);
        var remark = ref("");
        var show_status = ref(2);
        var audit_status = ref("approved");
        var defaultProps = computed(function() {
            return {
                children: "child",
                emitPath: false,
                label: "name",
                value: "id",
                multiple: true
            };
        });
        var handleBatchSave = function() {
            loading.value = true;
            // 修改标签
            if (props.operationType === OperationStatus.tags) {
                if (tag_ids.value.length) {
                    updateTemplate({
                        ids: props.ids,
                        tag_ids: tag_ids.value
                    }).then(function() {
                        successForm();
                    }).finally(function() {
                        loading.value = false;
                    });
                } else {
                    Message.error("\u8BF7\u9009\u62E9\u6807\u7B7E");
                    loading.value = false;
                }
            // 审核
            } else if (props.operationType === OperationStatus.audit) {
                templateAudit({
                    audit_status: audit_status.value,
                    ids: props.ids,
                    project_type: "template",
                    remark: audit_status.value === "rejected" ? remark.value : ""
                }).then(function() {
                    successForm();
                }).finally(function() {
                    loading.value = false;
                });
            // 上下架
            } else if (props.operationType === OperationStatus.show_status) {
                templateStatus({
                    ids: props.ids,
                    project_type: "template",
                    status: show_status.value
                }).then(function() {
                    successForm();
                }).finally(function() {
                    loading.value = false;
                });
            }
        };
        var handleClose = function() {
            resetFields();
            emit("update:visible", false);
        };
        return {
            loading: loading,
            remark: remark,
            tag_ids: tag_ids,
            show_status: show_status,
            audit_status: audit_status,
            defaultProps: defaultProps,
            template_tags: template_tags,
            showStatusOption: showStatusOption,
            OperationStatus: OperationStatus,
            handleClose: handleClose,
            handleBatchSave: handleBatchSave
        };
    }
});
